class DropHintJS {
  constructor() {
    this.form = document.querySelector('[data-dropahintform]');
    if (!this.form) return;

    this.formInputs = this.form.querySelectorAll('input:not([type="hidden"]), textarea');
    this.submitBtn = this.form.querySelector('[type="submit"]');

    this.requestHeader = { 'revision': '2024-02-15', 'content-type': 'application/json' };
    this.subscribeListURL = 'https://a.klaviyo.com/client/subscriptions/?company_id=R8AdKd';
    this.subscribeEventURL = 'https://a.klaviyo.com/client/events/?company_id=R8AdKd';
    this.recipientListId = 'XVCynm';
    this.senderListId = 'QU7wYu';

    this.form.addEventListener('submit', this.onFormSubmit.bind(this));
  }

  validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  onFormSubmit(evt) {
    evt.preventDefault();

    // Clear prev errors
    this.form.querySelectorAll('.error').forEach(el => el.classList.remove('error'));

    const data = new FormData(this.form);
    let valid = true;

    // Validate required fields
    ['sender_name', 'sender_email', 'recipient_name', 'recipient_email'].forEach(field => {
      const val = (data.get(field) || '').trim();
      if (!val) {
        this.form.querySelector(`#${field}`)?.classList.add('error');
        valid = false;
      }
    });

    // Validate emails
    ['sender_email', 'recipient_email'].forEach(field => {
      const val = (data.get(field) || '').trim();
      if (val && !this.validateEmail(val)) {
        this.form.querySelector(`#${field}`)?.classList.add('error');
        valid = false;
      }
    });

    if (!valid) return;

    this.submitBtn.setAttribute('disabled', true);
    this.form.classList.add('loading');

    const eventData = {
      type: 'event',
      attributes: {
        properties: {
          sender_name: data.get('sender_name'),
          sender_email: data.get('sender_email'),
          recipient_name: data.get('recipient_name'),
          recipient_email: data.get('recipient_email'),
          note: data.get('recipient_message'),
          product_title: data.get('product_title'),
          product_image: data.get('product_image'),
          product_link: `${window.location.origin}${data.get('product_link')}`
        },
        metric: { data: { type: 'metric', attributes: { name: 'Drop A Hint submission received' } } },
        profile: {
          data: {
            type: 'profile',
            attributes: { email: data.get('recipient_email') }
          }
        }
      }
    };

    fetch(this.subscribeEventURL, {
      method: 'POST',
      headers: this.requestHeader,
      body: JSON.stringify({ data: eventData })
    })
    .then(res => {
      if (res.status === 202) {
        this.subscribeRecipient(data.get('recipient_email'), data.get('sender_email'));
      } else {
        this.onError();
      }
    })
    .catch(() => this.onError());
  }

  subscribeRecipient(recipientEmail, senderEmail) {
    const data = {
      type: 'subscription',
      attributes: {
        custom_source: 'Drop A Hint custom form',
        profile: {
          data: { type: 'profile', attributes: { email: recipientEmail } }
        }
      },
      relationships: { list: { data: { type: 'list', id: this.recipientListId } } }
    };

    fetch(this.subscribeListURL, {
      method: 'POST',
      headers: this.requestHeader,
      body: JSON.stringify({ data })
    })
    .then(res => {
      if (res.status === 202) {
        this.subscribeSender(senderEmail);
        this.onSuccess();
      } else {
        res.text().then(t => console.error('Recipient subscribe failed:', t));
        this.onError();
      }
    })
    .catch(() => this.onError());
  }

  subscribeSender(senderEmail) {
    const data = {
      type: 'subscription',
      attributes: {
        profile: {
          data: { type: 'profile', attributes: { email: senderEmail } }
        }
      },
      relationships: { list: { data: { type: 'list', id: this.senderListId } } }
    };

    fetch(this.subscribeListURL, {
      method: 'POST',
      headers: this.requestHeader,
      body: JSON.stringify({ data })
    })
    .catch(err => console.error('Sender subscribe failed:', err));
  }

  onSuccess() {
    const formWrap = this.form.closest('.custom-contact-form');
    const successMsg = formWrap.querySelector('.dah-success-message');
    this.submitBtn.value = 'Sent!';

    // Hide form, show success
    this.form.style.display = 'none';
    successMsg.style.display = 'block';
    setTimeout(() => {
      successMsg.style.display = 'none';
      this.form.style.display = 'block';
      this.submitBtn.removeAttribute('disabled');
      this.form.classList.remove('loading');
      this.clearForm();
      this.submitBtn.value = 'Send To';
      const modal = document.getElementById("ProductPopup-DropHint");
      if (modal) modal.classList.remove("open");
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
    }, 4000);
  }

  onError() {
    this.submitBtn.removeAttribute('disabled');
    this.form.classList.remove('loading');
    alert('Something went wrong. Please try again.');
  }

  clearForm() {
    this.formInputs.forEach(input => input.value = '');
  }
}

document.addEventListener('DOMContentLoaded', () => new DropHintJS());